<main class="p-6 pb-10 ml-[52px] min-h-[calc(100vh_-_70px)] overflow-hidden max-w-[1400px]">
    @if (accessDenied()) {
    <section class="flex min-h-[calc(100vh_-_160px)] items-center justify-center text-center">
        <div class="max-w-lg">
            <h1 class="font-sh-bree text-3xl font-bold text-shs-white-1">Access denied</h1>
            <p class="mt-4 text-lg text-shs-gray-1">You do not have permission to access this COD.</p>
            <sag-ui-button class="mt-6" color="primary" (click)="cancelCreation()">Back to Dashboard</sag-ui-button>
        </div>
    </section>
    } @else {
    <div class="mb-6 flex justify-between items-center">
        <h1 class="text-shs-white-1 font-bold flex items-center gap-1 font-sh-bree" style="font-size: 30px">
            <span
                class="icon-chevron-left text-shs-orange text-3xl cursor-pointer"
                style="font-size: 30px"
                (click)="cancelCreation()"
            ></span>
            @if (selectedCod(); as data) { COD #{{ data.serial }}
            } @else {
            <span class="animate-pulse h-11 w-52 bg-[#333333] rounded-md"></span>
            }
        </h1>

        <div class="flex items-center gap-2">
            @if (selectedCod(); as data) { @if (data.status !== codStatus.CLOSED && canReassign) {
            <sag-ui-button icon="user" size="sm" color="tertiary" (click)="reassignCod()">Reassign COD</sag-ui-button>
            } }
            <sag-ui-button icon="download" size="sm" color="tertiary" (click)="printCod()" [disabled]="isPrinting">{{
                isPrinting ? 'Generating PDF...' : 'Print'
            }}</sag-ui-button>
            <sag-ui-button icon="close" size="sm" color="tertiary" (click)="cancelCreation()">Cancel</sag-ui-button>
        </div>
    </div>
    <div class="max-w-[1200px]">
        @if (selectedCod(); as data) {
        <app-cod-detail-card [data]="data"></app-cod-detail-card>
        } @else {
        <app-cod-detail-loading-card></app-cod-detail-loading-card>
        }

        <div class="h-4"></div>

        @if (selectedCod(); as data) { @if (data.region === regions.NAM) {
        <sag-ui-tabview>
            <sag-ui-tab value="overview" label="Customer Report">
                <div class="p-6 my-2">
                    @if (formGroup) {
                    <div
                        class="flex flex-col gap-8 pb-24 overflow-y-auto h-full w-full relative"
                        [formGroup]="formGroup"
                        ngxsForm="codDetail.form"
                    >
                        <app-cod-create-form
                            [formGroup]="formGroup"
                            [readonly]="true"
                            [steps]="steps()"
                        ></app-cod-create-form>
                    </div>
                    }
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="manager-review" label="Manager Review">
                <div class="p-6 my-2">
                    <app-cod-manager-review-step [disabled]="!canEditManagerReview"></app-cod-manager-review-step>
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="finance-review" label="Finance Review">
                <div class="p-6 my-2">
                    <app-cod-finance-review-step [disabled]="!canEditFinanceReview"></app-cod-finance-review-step>
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="investigation-review" label="Investigation Review">
                <div class="p-6 my-2">
                    <app-cod-investigation-review-domestic-step
                        [disabled]="!canEditInvestigationReview"
                    ></app-cod-investigation-review-domestic-step>
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="comments" label="Comments">
                <div class="p-6 my-2">
                    <app-cod-comments></app-cod-comments>
                </div>
            </sag-ui-tab>
        </sag-ui-tabview>
        } @else {
        <sag-ui-tabview>
            <sag-ui-tab value="overview" label="Customer Report">
                <div class="p-6 my-2">
                    @if (formGroup) {
                    <div
                        class="flex flex-col gap-8 pb-24 overflow-y-auto h-full w-full relative"
                        [formGroup]="formGroup"
                        ngxsForm="codDetail.form"
                    >
                        <app-cod-create-form
                            [formGroup]="formGroup"
                            [readonly]="true"
                            [steps]="steps()"
                        ></app-cod-create-form>
                    </div>
                    }
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="credit-review" label="Credit Review">
                <div class="p-6 my-2">
                    <app-cod-credit-review-step [disabled]="!canEditCreditReview"></app-cod-credit-review-step>
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="investigation-review" label="Investigation Review">
                <div class="p-6 my-2">
                    <app-cod-investigation-review-international-step
                        [disabled]="!canEditInvestigationReview"
                    ></app-cod-investigation-review-international-step>
                </div>
            </sag-ui-tab>
            <sag-ui-tab value="comments" label="Comments">
                <div class="p-6 my-2">
                    <app-cod-comments></app-cod-comments>
                </div>
            </sag-ui-tab>
        </sag-ui-tabview>
        } }
    </div>
    }
</main>

<!-- ═══════════════════════════════════════════════════════════
     PRINT-ONLY SECTION — hidden on screen, rendered only on print
     ═══════════════════════════════════════════════════════════ -->
@if (selectedCod(); as cod) {
<div id="cod-print-section">
    <!-- Header -->
    <div class="print-header">
        <div class="print-title">COD Report &mdash; #{{ cod.serial }}</div>
        <div class="print-meta">
            Status: {{ cod.status }} &nbsp;|&nbsp; Region: {{ cod.region }} &nbsp;|&nbsp; Printed: {{ printDate }}
        </div>
    </div>

    <!-- Overview Summary Block -->
    <div class="print-overview-block">
        <div class="print-grid">
            <div class="print-field">
                <span class="print-label">Nature of Complaint</span
                ><span class="print-value">{{ cod.natureOfComplaint }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">Reference Number</span
                ><span class="print-value">{{ cod.referenceNumber }}</span>
            </div>
            @if (cod.shipToCountryCode) {
            <div class="print-field">
                <span class="print-label">Country</span><span class="print-value">{{ cod.shipToCountryCode }}</span>
            </div>
            } @if (cod.financialAdjustmentValue) {
            <div class="print-field">
                <span class="print-label">Financial Adjustment</span
                ><span class="print-value">{{
                    cod.financialAdjustmentValue | currency : (cod.region === regions.NAM ? 'USD' : 'EUR')
                }}</span>
            </div>
            }
            <div class="print-field">
                <span class="print-label">Status</span><span class="print-value">{{ cod.status }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">Created By</span><span class="print-value">{{ cod.createdBy }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">Created On</span
                ><span class="print-value">{{ cod.createdAt | date : 'medium' }}</span>
            </div>
            @if (cod.affectedOrderLines && cod.affectedOrderLines.length > 0) {
            <div class="print-field">
                <span class="print-label">Order Date</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].soCreationDate | date }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">TU</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].transportUnit || '&mdash;' }}</span>
            </div>
            @if (cod.affectedOrderLines[0].salesOrderNumber) {
            <div class="print-field">
                <span class="print-label">Sales Order Number</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].salesOrderNumber }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].purchaseOrderReference) {
            <div class="print-field">
                <span class="print-label">Purchase Order Number</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].purchaseOrderReference }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].invoiceNumber) {
            <div class="print-field">
                <span class="print-label">Invoice Number</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].invoiceNumber }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].salesOrganisation) {
            <div class="print-field">
                <span class="print-label">Sales Organization</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].salesOrganisation }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].shipToCustomerNumber) {
            <div class="print-field">
                <span class="print-label">Ship To Customer No.</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].shipToCustomerNumber }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].shipToCustomerName) {
            <div class="print-field print-field--full">
                <span class="print-label">Ship To Customer Name</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].shipToCustomerName }}</span>
            </div>
            } @if (cod.affectedOrderLines[0].route) {
            <div class="print-field">
                <span class="print-label">Route</span
                ><span class="print-value">{{ cod.affectedOrderLines[0].route }}</span>
            </div>
            } } @if (cod.affectedOrderLines?.length) {
            <div class="print-field">
                <span class="print-label">Affected Items</span
                ><span class="print-value">{{ cod.affectedOrderLines!.length }} Order Line(s)</span>
            </div>
            } @if (cod.assignedTo) {
            <div class="print-field">
                <span class="print-label">Assigned To</span><span class="print-value">{{ cod.assignedTo }}</span>
            </div>
            }
        </div>
    </div>

    <!-- Customer Report Divider -->
    <div class="print-report-title">Customer Report</div>

    <!-- 1. Customer Information -->
    <div class="print-section">
        <div class="print-section-title">Customer Information</div>
        <div class="print-grid">
            <div class="print-field">
                <span class="print-label">Region</span><span class="print-value">{{ cod.region }}</span>
            </div>
        </div>
    </div>

    <!-- 2. Order Details -->
    <div class="print-section">
        <div class="print-section-title">Order Details</div>
        <div class="print-grid">
            <div class="print-field">
                <span class="print-label">Reference Number Type</span
                ><span class="print-value">{{ cod.referenceNumberType }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">Reference Number</span
                ><span class="print-value">{{ cod.referenceNumber }}</span>
            </div>
            @if (cod.productDiscrepancy !== null && cod.productDiscrepancy !== undefined) {
            <div class="print-field">
                <span class="print-label">Product Discrepancy</span
                ><span class="print-value">{{ cod.productDiscrepancy ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod).pgiWithin40Days !== null && $any(cod).pgiWithin40Days !== undefined) {
            <div class="print-field">
                <span class="print-label">PGI Within 40 Days</span
                ><span class="print-value">{{ $any(cod).pgiWithin40Days ? 'Yes' : 'No' }}</span>
            </div>
            }
            <div class="print-field print-field--full">
                <span class="print-label">Nature of Complaint</span
                ><span class="print-value">{{ cod.natureOfComplaint }}</span>
            </div>
        </div>
    </div>

    <!-- 3. Affected Items -->
    @if (cod.affectedOrderLines?.length || $any(cod).subType) {
    <div class="print-section">
        <div class="print-section-title">Affected Items</div>
        @if ($any(cod).subType) {
        <div class="print-grid" style="margin-bottom: 12px">
            @if ($any(cod.subType)?.issueType) {
            <div class="print-field">
                <span class="print-label">Issue Type</span
                ><span class="print-value">{{ $any(cod.subType)?.issueType }}</span>
            </div>
            } @if ($any(cod.subType)?.itemType) {
            <div class="print-field">
                <span class="print-label">Item Type</span
                ><span class="print-value">{{ $any(cod.subType)?.itemType }}</span>
            </div>
            } @if ($any(cod.subType)?.invoiceErrorType) {
            <div class="print-field">
                <span class="print-label">Invoice Error Type</span
                ><span class="print-value">{{ $any(cod.subType)?.invoiceErrorType }}</span>
            </div>
            } @if ($any(cod.subType)?.invoiceErrorTypeOtherInfo) {
            <div class="print-field print-field--full">
                <span class="print-label">Invoice Error (Other)</span
                ><span class="print-value">{{ $any(cod.subType)?.invoiceErrorTypeOtherInfo }}</span>
            </div>
            } @if ($any(cod.subType)?.countrySpecificLabelMissing) {
            <div class="print-field">
                <span class="print-label">Country-Specific Label</span
                ><span class="print-value">{{ $any(cod.subType)?.countrySpecificLabelMissing }}</span>
            </div>
            } @if ($any(cod.subType)?.labelError) {
            <div class="print-field">
                <span class="print-label">Label Error</span
                ><span class="print-value">{{ $any(cod.subType)?.labelError }}</span>
            </div>
            } @if ($any(cod.subType)?.unorderedItemSmn) {
            <div class="print-field">
                <span class="print-label">Unordered Item SMN</span
                ><span class="print-value">{{ $any(cod.subType)?.unorderedItemSmn }}</span>
            </div>
            } @if ($any(cod.subType)?.unorderedItemQuantity) {
            <div class="print-field">
                <span class="print-label">Unordered Item Quantity</span
                ><span class="print-value">{{ $any(cod.subType)?.unorderedItemQuantity }}</span>
            </div>
            }
        </div>
        } @if (cod.affectedOrderLines && cod.affectedOrderLines.length > 0) { @for (line of cod.affectedOrderLines;
        track $index) {
        <div class="print-order-line">
            <div class="print-subsection-title">Order Line {{ $index + 1 }}</div>
            <div class="print-grid">
                <div class="print-field">
                    <span class="print-label">Sales Order Number</span
                    ><span class="print-value">{{ line.salesOrderNumber || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Sales Order Line</span
                    ><span class="print-value">{{ line.salesOrderLine || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Purchase Order Ref.</span
                    ><span class="print-value">{{ line.purchaseOrderReference || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Invoice Number</span
                    ><span class="print-value">{{ line.invoiceNumber || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Delivery Number</span
                    ><span class="print-value">{{ line.deliveryNumber || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Transport Unit</span
                    ><span class="print-value">{{ line.transportUnit || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Handling Unit</span
                    ><span class="print-value">{{ line.handlingUnit || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Sales Organisation</span
                    ><span class="print-value">{{ line.salesOrganisation || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">SO Creation Date</span
                    ><span class="print-value">{{ line.soCreationDate | date }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Ship-To Customer No.</span
                    ><span class="print-value">{{ line.shipToCustomerNumber || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Ship-To Customer Name</span
                    ><span class="print-value">{{ line.shipToCustomerName || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Ship-To Country</span
                    ><span class="print-value">{{ line.shipToCountryCode || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Source Plant</span
                    ><span class="print-value">{{ line.sourcePlant || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Source Country</span
                    ><span class="print-value">{{ line.sourceCountry || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">SMN</span><span class="print-value">{{ line.smn || '&mdash;' }}</span>
                </div>
                <div class="print-field print-field--full">
                    <span class="print-label">Material Description</span
                    ><span class="print-value">{{ line.materialDescription || '&mdash;' }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Sales Order Quantity</span
                    ><span class="print-value">{{ line.salesOrderQuantity }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Affected Quantity</span
                    ><span class="print-value">{{ line.affectedQuantity }}</span>
                </div>
                <div class="print-field">
                    <span class="print-label">Price</span
                    ><span class="print-value">{{
                        line.price | currency : (cod.region === regions.NAM ? 'USD' : 'EUR')
                    }}</span>
                </div>
                @if (line.route) {
                <div class="print-field">
                    <span class="print-label">Route</span><span class="print-value">{{ line.route }}</span>
                </div>
                }
            </div>
        </div>
        } }
    </div>
    }

    <!-- 4. Additional Information -->
    @if (cod.additionalInfo || $any(cod).relatedNumber || $any(cod).relatedTrackingNumber || $any(cod).managerGid ||
    $any(cod).filedWithin30Days !== null || $any(cod).financialAdjustmentRequest || $any(cod).subType) {
    <div class="print-section">
        <div class="print-section-title">Additional Information</div>
        <div class="print-grid">
            @if (cod.additionalInfo) {
            <div class="print-field print-field--full">
                <span class="print-label"
                    >Provide any additional information that will aid in the Rootcause Investigation</span
                ><span class="print-value">{{ cod.additionalInfo }}</span>
            </div>
            } @if ($any(cod).relatedNumber) {
            <div class="print-field">
                <span class="print-label">Related Credit/Debit Number</span
                ><span class="print-value">{{ $any(cod).relatedNumber }}</span>
            </div>
            } @if ($any(cod).relatedTrackingNumber) {
            <div class="print-field">
                <span class="print-label">Call Tag Tracking Number</span
                ><span class="print-value">{{ $any(cod).relatedTrackingNumber }}</span>
            </div>
            } @if ($any(cod).managerGid) {
            <div class="print-field">
                <span class="print-label">Manager GID</span><span class="print-value">{{ $any(cod).managerGid }}</span>
            </div>
            } @if ($any(cod).filedWithin30Days !== null && $any(cod).filedWithin30Days !== undefined) {
            <div class="print-field">
                <span class="print-label">Filed Within 30 Days</span
                ><span class="print-value">{{ $any(cod).filedWithin30Days ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod).financialAdjustmentRequest) {
            <div class="print-field">
                <span class="print-label">Financial Adjustment Request</span
                ><span class="print-value">{{ $any(cod).financialAdjustmentRequest }}</span>
            </div>
            } @if ($any(cod.subType)?.shipmentNumber) {
            <div class="print-field">
                <span class="print-label">Shipment / TU Number</span
                ><span class="print-value">{{ $any(cod.subType)?.shipmentNumber }}</span>
            </div>
            } @if ($any(cod.subType)?.incorrectDeliveryInDocumentation !== null &&
            $any(cod.subType)?.incorrectDeliveryInDocumentation !== undefined) {
            <div class="print-field">
                <span class="print-label">Doc Matches Delivery Address</span
                ><span class="print-value">{{
                    $any(cod.subType)?.incorrectDeliveryInDocumentation ? 'Yes' : 'No'
                }}</span>
            </div>
            } @if ($any(cod.subType)?.deliveryDocumentationIncorrectAddress !== null &&
            $any(cod.subType)?.deliveryDocumentationIncorrectAddress !== undefined) {
            <div class="print-field">
                <span class="print-label">Delivery Doc Incorrect Address</span
                ><span class="print-value">{{
                    $any(cod.subType)?.deliveryDocumentationIncorrectAddress ? 'Yes' : 'No'
                }}</span>
            </div>
            } @if ($any(cod.subType)?.incorrectDeliveryAddress) {
            <div class="print-field print-field--full">
                <span class="print-label">Incorrect Delivery Address</span
                ><span class="print-value">{{ $any(cod.subType)?.incorrectDeliveryAddress }}</span>
            </div>
            } @if ($any(cod.subType)?.wrongCarrier) {
            <div class="print-field">
                <span class="print-label">Wrong Carrier</span
                ><span class="print-value">{{ $any(cod.subType)?.wrongCarrier }}</span>
            </div>
            } @if ($any(cod.subType)?.ainErrorType) {
            <div class="print-field">
                <span class="print-label">AIN Error Type</span
                ><span class="print-value">{{ $any(cod.subType)?.ainErrorType }}</span>
            </div>
            } @if ($any(cod.subType)?.replacementOrderRequired !== null && $any(cod.subType)?.replacementOrderRequired
            !== undefined) {
            <div class="print-field">
                <span class="print-label">Replacement Order Required</span
                ><span class="print-value">{{ $any(cod.subType)?.replacementOrderRequired ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.replacementOrderNumber) {
            <div class="print-field">
                <span class="print-label">Replacement Order Number</span
                ><span class="print-value">{{ $any(cod.subType)?.replacementOrderNumber }}</span>
            </div>
            } @if ($any(cod.subType)?.documentationIssue) {
            <div class="print-field">
                <span class="print-label">Documentation Issue</span
                ><span class="print-value">{{ $any(cod.subType)?.documentationIssue }}</span>
            </div>
            } @if ($any(cod.subType)?.documentationIssueOtherInfo) {
            <div class="print-field print-field--full">
                <span class="print-label">Documentation Issue (Other)</span
                ><span class="print-value">{{ $any(cod.subType)?.documentationIssueOtherInfo }}</span>
            </div>
            } @if ($any(cod.subType)?.containedSpecialInstructions !== null &&
            $any(cod.subType)?.containedSpecialInstructions !== undefined) {
            <div class="print-field">
                <span class="print-label">Contained Special Instructions</span
                ><span class="print-value">{{ $any(cod.subType)?.containedSpecialInstructions ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.documentationError) {
            <div class="print-field">
                <span class="print-label">Documentation Error</span
                ><span class="print-value">{{ $any(cod.subType)?.documentationError }}</span>
            </div>
            } @if ($any(cod.subType)?.documentationErrorOtherInfo) {
            <div class="print-field print-field--full">
                <span class="print-label">Documentation Error (Other)</span
                ><span class="print-value">{{ $any(cod.subType)?.documentationErrorOtherInfo }}</span>
            </div>
            } @if ($any(cod.subType)?.errorsIdentifiedWithin24hours !== null &&
            $any(cod.subType)?.errorsIdentifiedWithin24hours !== undefined) {
            <div class="print-field">
                <span class="print-label">Errors Identified Within 24h</span
                ><span class="print-value">{{ $any(cod.subType)?.errorsIdentifiedWithin24hours ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.invoiceMatchesIODC !== null && $any(cod.subType)?.invoiceMatchesIODC !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Invoice Matches IODC</span
                ><span class="print-value">{{ $any(cod.subType)?.invoiceMatchesIODC ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.instructionsContained !== null && $any(cod.subType)?.instructionsContained !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Instructions Contained</span
                ><span class="print-value">{{ $any(cod.subType)?.instructionsContained ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.csrGID) {
            <div class="print-field">
                <span class="print-label">CSR GID</span><span class="print-value">{{ $any(cod.subType)?.csrGID }}</span>
            </div>
            } @if ($any(cod.subType)?.accountErrorType) {
            <div class="print-field">
                <span class="print-label">Account Error Type</span
                ><span class="print-value">{{ $any(cod.subType)?.accountErrorType }}</span>
            </div>
            } @if ($any(cod.subType)?.orderTypeIncorrectlyUsed) {
            <div class="print-field">
                <span class="print-label">Order Type Incorrectly Used</span
                ><span class="print-value">{{ $any(cod.subType)?.orderTypeIncorrectlyUsed }}</span>
            </div>
            } @if ($any(cod.subType)?.correctOrderType) {
            <div class="print-field">
                <span class="print-label">Correct Order Type</span
                ><span class="print-value">{{ $any(cod.subType)?.correctOrderType }}</span>
            </div>
            } @if ($any(cod.subType)?.errorDescription) {
            <div class="print-field print-field--full">
                <span class="print-label">Error Description</span
                ><span class="print-value">{{ $any(cod.subType)?.errorDescription }}</span>
            </div>
            } @if ($any(cod.subType)?.canIdentifyCartonId !== null && $any(cod.subType)?.canIdentifyCartonId !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Can Identify Carton ID</span
                ><span class="print-value">{{ $any(cod.subType)?.canIdentifyCartonId ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.cartonId) {
            <div class="print-field">
                <span class="print-label">Carton ID</span
                ><span class="print-value">{{ $any(cod.subType)?.cartonId }}</span>
            </div>
            } @if ($any(cod.subType)?.conditionOfItem?.length) {
            <div class="print-field print-field--full">
                <span class="print-label">Condition of Item</span
                ><span class="print-value">{{ $any(cod.subType)?.conditionOfItem?.join(', ') }}</span>
            </div>
            } @if ($any(cod.subType)?.packageType) {
            <div class="print-field">
                <span class="print-label">Package Type</span
                ><span class="print-value">{{ $any(cod.subType)?.packageType }}</span>
            </div>
            } @if ($any(cod.subType)?.protectivePackagingUsed !== null && $any(cod.subType)?.protectivePackagingUsed !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Protective Packaging Used</span
                ><span class="print-value">{{ $any(cod.subType)?.protectivePackagingUsed ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.packageTypeCondition) {
            <div class="print-field">
                <span class="print-label">Package Condition</span
                ><span class="print-value">{{ $any(cod.subType)?.packageTypeCondition }}</span>
            </div>
            } @if ($any(cod.subType)?.documentationNotedIssue !== null && $any(cod.subType)?.documentationNotedIssue !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Documentation Noted Issue</span
                ><span class="print-value">{{ $any(cod.subType)?.documentationNotedIssue ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.explanationOfMissingNote) {
            <div class="print-field print-field--full">
                <span class="print-label">Explanation of Missing Note</span
                ><span class="print-value">{{ $any(cod.subType)?.explanationOfMissingNote }}</span>
            </div>
            } @if ($any(cod.subType)?.damageClaimFiled !== null && $any(cod.subType)?.damageClaimFiled !== undefined) {
            <div class="print-field">
                <span class="print-label">Damage Claim Filed</span
                ><span class="print-value">{{ $any(cod.subType)?.damageClaimFiled ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.carrierTrackingNumber) {
            <div class="print-field">
                <span class="print-label">Carrier Tracking Number</span
                ><span class="print-value">{{ $any(cod.subType)?.carrierTrackingNumber }}</span>
            </div>
            } @if ($any(cod.subType)?.additionalPackagingInfo) {
            <div class="print-field print-field--full">
                <span class="print-label">Additional Packaging Info</span
                ><span class="print-value">{{ $any(cod.subType)?.additionalPackagingInfo }}</span>
            </div>
            } @if ($any(cod.subType)?.claimFiled !== null && $any(cod.subType)?.claimFiled !== undefined) {
            <div class="print-field">
                <span class="print-label">Claim Filed</span
                ><span class="print-value">{{ $any(cod.subType)?.claimFiled ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.declinedWithin24Hours !== null && $any(cod.subType)?.declinedWithin24Hours !==
            undefined) {
            <div class="print-field">
                <span class="print-label">Declined Within 24h</span
                ><span class="print-value">{{ $any(cod.subType)?.declinedWithin24Hours ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.batchExpiryMeetsMinShipPolicy !== null &&
            $any(cod.subType)?.batchExpiryMeetsMinShipPolicy !== undefined) {
            <div class="print-field">
                <span class="print-label">Batch Expiry Meets Min Ship Policy</span
                ><span class="print-value">{{ $any(cod.subType)?.batchExpiryMeetsMinShipPolicy ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.materialDisposition) {
            <div class="print-field">
                <span class="print-label">Material Disposition</span
                ><span class="print-value">{{ $any(cod.subType)?.materialDisposition }}</span>
            </div>
            } @if ($any(cod.subType)?.lotsDeclinedWithin24Hours !== null && $any(cod.subType)?.lotsDeclinedWithin24Hours
            !== undefined) {
            <div class="print-field">
                <span class="print-label">Lots Declined Within 24h</span
                ><span class="print-value">{{ $any(cod.subType)?.lotsDeclinedWithin24Hours ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.identificationDate) {
            <div class="print-field">
                <span class="print-label">Identification Date</span
                ><span class="print-value">{{ $any(cod.subType)?.identificationDate | date }}</span>
            </div>
            } @if ($any(cod.subType)?.identificationLocation) {
            <div class="print-field">
                <span class="print-label">Identification Location</span
                ><span class="print-value">{{ $any(cod.subType)?.identificationLocation }}</span>
            </div>
            } @if ($any(cod.subType)?.exactLocation) {
            <div class="print-field print-field--full">
                <span class="print-label">Exact Location</span
                ><span class="print-value">{{ $any(cod.subType)?.exactLocation }}</span>
            </div>
            } @if ($any(cod.subType)?.identificationBy) {
            <div class="print-field">
                <span class="print-label">Identified By</span
                ><span class="print-value">{{ $any(cod.subType)?.identificationBy }}</span>
            </div>
            } @if ($any(cod.subType)?.temperatureRequirementsIncluded !== null &&
            $any(cod.subType)?.temperatureRequirementsIncluded !== undefined) {
            <div class="print-field">
                <span class="print-label">Temperature Requirements Included</span
                ><span class="print-value">{{
                    $any(cod.subType)?.temperatureRequirementsIncluded ? 'Yes' : 'No'
                }}</span>
            </div>
            } @if ($any(cod.subType)?.issueNotedInDocumentation !== null && $any(cod.subType)?.issueNotedInDocumentation
            !== undefined) {
            <div class="print-field">
                <span class="print-label">Issue Noted in Documentation</span
                ><span class="print-value">{{ $any(cod.subType)?.issueNotedInDocumentation ? 'Yes' : 'No' }}</span>
            </div>
            } @if ($any(cod.subType)?.issueNotNotedExplanation) {
            <div class="print-field print-field--full">
                <span class="print-label">Explanation for Missing Note</span
                ><span class="print-value">{{ $any(cod.subType)?.issueNotNotedExplanation }}</span>
            </div>
            } @if ($any(cod.subType)?.explanation) {
            <div class="print-field print-field--full">
                <span class="print-label">Temperature Excursion Explanation</span
                ><span class="print-value">{{ $any(cod.subType)?.explanation }}</span>
            </div>
            }
        </div>
    </div>
    }

    <!-- 5. Credit Review (International only) -->
    @if (cod.region !== regions.NAM && creditReview()) {
    <div class="print-section">
        <div class="print-section-title">Credit Review</div>
        <div class="print-grid">
            <div class="print-field">
                <span class="print-label">Financial Adjustment (EUR)</span
                ><span class="print-value">{{ creditReview()!.financialAdjustment || '&mdash;' }}</span>
            </div>
        </div>
    </div>
    }

    <!-- 6. Manager Review (NAM only) -->
    @if (cod.region === regions.NAM && managerReview()) {
    <div class="print-section">
        <div class="print-section-title">Manager Review</div>
        <div class="print-grid">
            <div class="print-field print-field--full">
                <span class="print-label">Related Manager Review</span
                ><span class="print-value">{{ managerReview()!.relatedManagerReview || '&mdash;' }}</span>
            </div>
            @if (managerReview()!.reasonForDenial) {
            <div class="print-field print-field--full">
                <span class="print-label">Reason for Denial</span
                ><span class="print-value">{{ managerReview()!.reasonForDenial }}</span>
            </div>
            } @if (managerReview()!.nextStep) {
            <div class="print-field">
                <span class="print-label">Next Step</span
                ><span class="print-value">{{ managerReview()!.nextStep }}</span>
            </div>
            }
        </div>
    </div>
    }

    <!-- 7. Finance Review (NAM only) -->
    @if (cod.region === regions.NAM && financeReview()) {
    <div class="print-section">
        <div class="print-section-title">Finance Review</div>
        <div class="print-grid">
            <div class="print-field print-field--full">
                <span class="print-label">Finance COD Review</span
                ><span class="print-value">{{ financeReview()!.financeCodReview || '&mdash;' }}</span>
            </div>
            @if (financeReview()!.reasonForDenial) {
            <div class="print-field print-field--full">
                <span class="print-label">Reason for Denial</span
                ><span class="print-value">{{ financeReview()!.reasonForDenial }}</span>
            </div>
            } @if (financeReview()!.nextStep) {
            <div class="print-field">
                <span class="print-label">Next Step</span
                ><span class="print-value">{{ financeReview()!.nextStep }}</span>
            </div>
            }
        </div>
    </div>
    }

    <!-- 8a. Investigation Review — International -->
    @if (cod.region !== regions.NAM && investigationReviewInt()) {
    <div class="print-section">
        <div class="print-section-title">Investigation Review</div>
        <div class="print-grid">
            <div class="print-field print-field--full">
                <span class="print-label">Nature of Complaint</span
                ><span class="print-value">{{ investigationReviewInt()!.natureOfComplaint || '&mdash;' }}</span>
            </div>
            @if (investigationReviewInt()!.issueType) {
            <div class="print-field">
                <span class="print-label">Issue Type</span
                ><span class="print-value">{{ investigationReviewInt()!.issueType }}</span>
            </div>
            }
            <div class="print-field">
                <span class="print-label">Root Cause</span
                ><span class="print-value">{{ investigationReviewInt()!.rootCause || '&mdash;' }}</span>
            </div>
            <div class="print-field">
                <span class="print-label">Through</span
                ><span class="print-value">{{ investigationReviewInt()!.through || '&mdash;' }}</span>
            </div>
            <div class="print-field print-field--full">
                <span class="print-label">Investigator Additional Details</span
                ><span class="print-value">{{ investigationReviewInt()!.details || '&mdash;' }}</span>
            </div>
            @if ($any(investigationReviewInt())?.investigationReviewRelatedDocuments?.length) {
            <div class="print-field print-field--full">
                <span class="print-label">Attachments / Related Documents</span
                ><span class="print-value">{{
                    $any(investigationReviewInt())?.investigationReviewRelatedDocuments?.join(', ')
                }}</span>
            </div>
            }
            <div class="print-field print-field--full">
                <span class="print-label">Investigator COD Disposition</span
                ><span class="print-value">{{ investigationReviewInt()!.investigatorReviewResult || '&mdash;' }}</span>
            </div>
            @if (investigationReviewInt()!.reasonForDenial) {
            <div class="print-field print-field--full">
                <span class="print-label">Reason for Denial</span
                ><span class="print-value">{{ investigationReviewInt()!.reasonForDenial }}</span>
            </div>
            }
        </div>
    </div>
    }

    <!-- 8b. Investigation Review — Domestic -->
    @if (cod.region === regions.NAM && investigationReviewDomestic()) {
    <div class="print-section">
        <div class="print-section-title">Investigation Review</div>
        <div class="print-grid">
            <div class="print-field print-field--full">
                <span class="print-label">Nature of Complaint</span
                ><span class="print-value">{{ investigationReviewDomestic()!.natureOfComplaint || '&mdash;' }}</span>
            </div>
            @if (investigationReviewDomestic()!.issueType) {
            <div class="print-field">
                <span class="print-label">Issue Type</span
                ><span class="print-value">{{ investigationReviewDomestic()!.issueType }}</span>
            </div>
            }
            <div class="print-field">
                <span class="print-label">Root Cause</span
                ><span class="print-value">{{ investigationReviewDomestic()!.rootCause || '&mdash;' }}</span>
            </div>
            @if (investigationReviewDomestic()!.through) {
            <div class="print-field">
                <span class="print-label">Through</span
                ><span class="print-value">{{ investigationReviewDomestic()!.through }}</span>
            </div>
            } @if (investigationReviewDomestic()!.csrResponsible) {
            <div class="print-field">
                <span class="print-label">CSR Responsible</span
                ><span class="print-value">{{ investigationReviewDomestic()!.csrResponsible }}</span>
            </div>
            }
            <div class="print-field print-field--full">
                <span class="print-label">Investigator Additional Details</span
                ><span class="print-value">{{ investigationReviewDomestic()!.details || '&mdash;' }}</span>
            </div>
            @if ($any(investigationReviewDomestic())?.investigationReviewRelatedDocuments?.length) {
            <div class="print-field print-field--full">
                <span class="print-label">Attachments / Related Documents</span
                ><span class="print-value">{{
                    $any(investigationReviewDomestic())?.investigationReviewRelatedDocuments?.join(', ')
                }}</span>
            </div>
            }
            <div class="print-field print-field--full">
                <span class="print-label">Investigator COD Disposition</span
                ><span class="print-value">{{
                    investigationReviewDomestic()!.investigatorReviewResult || '&mdash;'
                }}</span>
            </div>
            @if (investigationReviewDomestic()!.reasonForDenial) {
            <div class="print-field print-field--full">
                <span class="print-label">Reason for Denial</span
                ><span class="print-value">{{ investigationReviewDomestic()!.reasonForDenial }}</span>
            </div>
            } @if (investigationReviewDomestic()!.nextStep) {
            <div class="print-field">
                <span class="print-label">Next Step</span
                ><span class="print-value">{{ investigationReviewDomestic()!.nextStep }}</span>
            </div>
            }
        </div>
    </div>
    }

    <div class="print-footer">This document was generated from the COD Management System.</div>
</div>
}
